export default __webpack_public_path__ + "static/media/brand7.cecb6c77.svg";